import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const UpdateCustomerStatus = createAsyncThunk(
  "UpdateCustomerStatus",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/UpdateStatus",

        {
            Update: data1[0],
            OrderNo: data1[1],
            Data: data1[2],
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error.code === "ERR_NETWORK") {
        return rejectWithValue("ERROR");
      }
    }
  }
);

const UpdateCustomerSlice = createSlice({
  name: "UpdateCustomer",
  initialState: {
    isLoading: "hide",
    isSuccessFull:false
  },
  extraReducers: (builder) => {
    builder
      .addCase(UpdateCustomerStatus.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isSuccessFull=true;
      })
      .addCase(UpdateCustomerStatus.pending, (state, action) => {
        state.isLoading = "";
        state.isSuccessFull=false;
      })
  },
});

export default UpdateCustomerSlice.reducer;
